import { SIGNUP } from "../types";

export const signupReducer = (state = {}, action) => {
  switch (action.type) {
    case SIGNUP:
      return { ...state, loggedIn: true, login: action.payload };
    default:
      return state;
  }
};
